import {ChangeDetectionStrategy, Component, TemplateRef, input, output} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {Panel} from 'primeng/panel';
import {DirectusTooltipComponent} from '../../directus-tooltip/directus-tooltip.component';
import {BadgeListItem, BadgeListItemContext, BadgeListItemToggle} from './badge-list.types';
import {TranslateDirectusPipe} from '@frontend/transloco';

@Component({
  selector: 'app-badge-list',
  imports: [NgTemplateOutlet, Panel, DirectusTooltipComponent, TranslateDirectusPipe],
  templateUrl: './badge-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeListComponent {
  readonly items = input<BadgeListItem[]>([]);
  readonly headerInputTemplate = input<TemplateRef<BadgeListItemContext> | null>(null);
  readonly contentTemplate = input<TemplateRef<BadgeListItemContext> | null>(null);
  readonly isOpenable = input(true);
  readonly openableItemKeys = input<ReadonlySet<string>>(new Set());

  readonly itemToggle = output<BadgeListItemToggle>();

  protected isItemOpenable(item: BadgeListItem): boolean {
    return this.isOpenable() || this.openableItemKeys().has(item.key);
  }

  protected onCollapsedChange(item: BadgeListItem, collapsed: boolean | undefined): void {
    this.itemToggle.emit({key: item.key, collapsed: collapsed ?? true});
  }
}
